import React from 'react';
import { Gauge } from 'lucide-react';
import { formatDay } from '../../lib/overOrder';

/**
 * "Best day 180 · cap 216" pill on a product. Turns amber once the quantity in
 * the cart passes the cap. Tapping it drops the line back to the cap.
 *
 * Only ever rendered for a Guaranteed-Returns client with enough recorded
 * deliveries of that product to have a peak worth calling one.
 */
export const CapChip = ({ cap, orderedQty = 0, onUseCap, className = '' }) => {
  if (!cap || !cap.cap_qty) return null;
  const over = orderedQty > cap.cap_qty;
  const tip = over
    ? `${orderedQty} is ${orderedQty - cap.cap_qty} above the ceiling for this product. Your best single delivery was ${cap.peak_sold}${cap.peak_date ? ` on ${formatDay(cap.peak_date)}` : ''}; the ceiling adds ${Math.round(cap.allowance_pct - 100)}%.`
    : `Your best single delivery was ${cap.peak_sold}${cap.peak_date ? ` on ${formatDay(cap.peak_date)}` : ''} across ${cap.deliveries} deliveries. The ceiling adds ${Math.round(cap.allowance_pct - 100)}%.`;

  const body = (
    <>
      <Gauge className="h-3 w-3 shrink-0" />
      <span>
        Best day {cap.peak_sold} · cap {cap.cap_qty}
      </span>
      {over && <span className="font-semibold">· +{orderedQty - cap.cap_qty}</span>}
    </>
  );

  const shared = `inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium transition-colors ${
    over
      ? 'border-orange-300 bg-orange-50 text-orange-800 hover:bg-orange-100'
      : 'border-slate-200 bg-slate-50 text-slate-600'
  } ${className}`;

  if (over && onUseCap) {
    return (
      <button
        type="button"
        title={`${tip} Tap to use the cap (${cap.cap_qty}).`}
        onClick={(e) => { e.stopPropagation(); onUseCap(cap.cap_qty); }}
        className={shared}
        data-testid={`cap-chip-${cap.product_id}`}
        data-over-cap="true"
      >
        {body}
      </button>
    );
  }

  return (
    <span
      title={tip}
      className={shared}
      data-testid={`cap-chip-${cap.product_id}`}
      data-over-cap={over ? 'true' : 'false'}
    >
      {body}
    </span>
  );
};

export default CapChip;
